// separate file so the service doesnt get too busy

import { globalFields } from "./global-fields";


const exampleParent = {
    fields: [
        globalFields.organization.id,
        globalFields.organization.tags
    ],
    customFields: [

    ]
}

const typeIdentifier = {
    fields: [
        globalFields.organization.id,
        {
            name: 'typeIdentifiers',
            label: 'Organization Entity Type',
            validators: { minlength: 1, required: true }
        },
    ],
    customFields: [
    ]
};

const primaryInformation = {
    fields: [
        globalFields.organization.tags,
        globalFields.organization.name,
        globalFields.organization.class,
        globalFields.organization.status,
        globalFields.organization.id,
        globalFields.organization.agencyCode,
        globalFields.organization.agencyORI,
        globalFields.organization.agencyType,
        globalFields.organization.judges,
        globalFields.organization.courtIdentifier
    ],
    customFields: []
};

const contactInformation = {
    fields: [
        {
            name: 'phoneNumbers',
            label: 'Phone Numbers',
            array: [
                {
                    name: 'typeId',
                    label: 'Type',
                    validators: {
                        required: true
                    }
                },
                {
                    name: 'contactValue',
                    label: 'Phone Number',
                    validators: {
                        required: true,
                        pattern: '^\\+?[0-9]{0,3}\\s?\\(?[0-9]{3}\\)?[-\\s\\.]?[0-9]{3}[-\\s\\.]?[0-9]{4,7}$'
                    }
                },
                {
                    name: 'contactSuffix',
                    label: 'Extension',
                    validators: {
                        pattern: '^[x,X]?[0-9]+$',
                        maxlength: 20
                    }
                },
                {
                    name: 'isPrimary',
                    label: 'Primary',
                    validators: {}
                }
            ]
        },
        {
            name: 'emailAddresses',
            label: 'Email',
            array: [
                {
                    name: 'emailAddressTypeId',
                    label: 'Type',
                    validators: {}
                },
                {
                    name: 'contactValue',
                    label: 'Email',
                    validators: {
                        required: true,
                        email: true
                    }
                },
                {
                    name: 'isPrimary',
                    label: 'Primary',
                    validators: {}
                }
            ]
        },
        {
            name: 'webAddresses',
            label: 'Web Address (URL)',
            array: [
                {
                    name: 'webAddressTypeId',
                    label: 'Type',
                    validators: {}
                },
                {
                    name: 'contactValue',
                    label: 'Web Address',
                    validators: {
                        required: true
                    }
                },
                {
                    name: 'isPrimary',
                    label: 'Primary',
                    validators: {}
                }
            ]
        }
    ],
    customFields: []
};

const organizationIdentifiers = {
    fields: [
        {
            name: 'organizationIdentifiers',
            label: 'Official Issued Numbers',
            array: [
                {
                    name: 'organizationIdentifierTypeId',
                    label: 'Type',
                    validators: {
                        required: true
                    }
                },
                {
                    name: 'identifier',
                    label: 'Value',
                    validators: {
                        required: true,
                        maxlength: 20
                    }
                },
                {
                    name: 'otherAuthority',
                    label: 'Issuing Authority',
                    validators: {
                    }
                },
                {
                    name: 'issuedOn',
                    label: 'Issue Date',
                    validators: {
                    }
                },
                {
                    name: 'expiresOn',
                    label: 'Expiration Date',
                    validators: {
                    }
                },
                {
                    name: 'id',
                    validators: {
                    }
                }
            ]
        }
    ],
    customFields: []
};


const criminalOrganizationDetail = {
    fields: [
        globalFields.organization.id,
        {
            name: 'criminalOrganizationScopeId',
            label: 'Scope',
            validators: { required: true }
        },
        {
            name: 'estimatedNumberOfMembers',
            label: 'Estimated Number of Members',
            validators: { required: true }
        },
        {
            name: 'primarySexId',
            label: 'Primary Gender'
        },
        {
            name: 'juvenileGang',
            label: 'Juvenile Gang'
        },
        {
            name: 'isHateGroup',
            label: 'Is Hate Group'
        },
        {
            name: 'colors',
            label: 'Colors'
        },
        {
            name: 'nationalities',
            label: 'Nationality of Members'
        },
        {
            name: 'symbolsUsed',
            label: 'Description of Symbols Used'
        },
        {
            name: 'termsUsed',
            label: 'Terms Used'
        },
        {
            name: 'criminalOrganizationActivityIds',
            label: 'Types of Activities',
            validators: { minlength: 1, required: true }
        },
        {
            name: 'schools',
            label: 'Schools',
        }
    ],
    customFields: []
}

const location = {
    fields: [
        {
            name: 'involvement',
            label: 'Involvement',
            validators: { required: true },
        },
        {
            name: 'isPrimary',
            label: 'Primary',
            validators: {},
        }
    ],
    customFields: [],
};

export const organizationExampleFields = {
    fields: [...exampleParent.fields],
    customFields: [...exampleParent.customFields]
}

export const organizationTypeIdentifierFields = {
    fields: [...typeIdentifier.fields],
    customFields: [...typeIdentifier.customFields]
};

export const organizationPrimaryInformationFields = {
    fields: [...primaryInformation.fields],
    customFields: [...primaryInformation.customFields]
};

export const organizationContactInformationFields = {
    fields: [...contactInformation.fields],
    customFields: [...contactInformation.customFields]
};

export const organizationIdentifiersFields = {
    fields: [...organizationIdentifiers.fields],
    customFields: [...organizationIdentifiers.customFields]
};

export const organizationCriminalOrganizationDetailFields = {
    fields: [...criminalOrganizationDetail.fields],
    customFields: [...criminalOrganizationDetail.customFields]
}

export const organizationLocationFields = {
    fields: [...location.fields],
    customFields: [...location.customFields]
}